import type { HITLConfig } from '../../tool-config-types';

/**
 * HITL config for HTTP tools
 * Simply passes args through as-is
 */
export const httpHitlConfig: HITLConfig = {
  extractData: (args: Record<string, unknown>): unknown[] => [args],
  wrapEditedData: (data: unknown[]): Record<string, unknown> =>
    (data[0] as Record<string, unknown>) || {},
};
